import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getCountries, getStates } from './api';

export function useGetCountries(options?: UseQueryOptions<{ value: string | number; label: string }[], Error>) {
  return useQuery<{ value: string | number; label: string }[]>({
    queryKey: ['countries'],
    queryFn: () => getCountries(),
    ...options
  });
}

export function useGetStates(
  countryCode: string,
  options?: UseQueryOptions<{ value: string | number; label: string }[], Error>
) {
  return useQuery<{ value: string | number; label: string }[]>({
    queryKey: ['states', countryCode],
    queryFn: () => getStates(countryCode),
    ...options
  });
}
